// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Ecclesiasticus (Sirach)",
  bookSlug: "ecclesiasticus",
  chapter: 8,
  argument: "Other lessons of wisdom and virtue.",
  verses: [
    { n: 1, text: "Strive not with a powerful man, lest thou fall into his hands." },
    { n: 2, text: "Contend not with a rich man, lest he bring an action against thee." },
    { n: 3, text: "For gold and silver hath destroyed many, and hath reached even to the heart of kings, and perverted them." },
    { n: 4, text: "Strive not with a man that is full of tongue, and heap not wood upon his fire." },
    { n: 5, text: "Communicate not with an ignorant man, lest he speak ill of thy family." },
    { n: 6, text: "Despise not a man that turneth away from sin, nor reproach him therewith: remember that we are all worthy of reproof." },
    { n: 7, text: "Despise not a man in his old age: for we also shall become old." },
    { n: 8, text: "Rejoice not at the death of thy enemy: knowing that we all die, and are not willing that others should rejoice at our death." },
    { n: 9, text: "Despise not the discourse of them that are ancient and wise, but acquaint thyself with their proverbs." },
    { n: 10, text: "For of them thou shalt learn wisdom, and instruction of understanding, and to serve great men without blame." },
    { n: 11, text: "Let not the discourse of the ancients escape thee, for they have learned of their fathers:" },
    { n: 12, text: "For of them thou shalt learn understanding, and to give an answer in time of need." },
    { n: 13, text: "Kindle not the coals of sinners by rebuking them, lest thou be burnt with the flame of the fire of their sins." },
    { n: 14, text: "Stand not against the face of an injurious person, lest he sit as a spy to entrap thee in thy words." },
    { n: 15, text: "Lend not to a man that is mightier than thyself: and if thou lendest, count it as lost." },
    { n: 16, text: "Be not surety above thy power: and if thou be surety, think as if thou wert to pay it." },
    { n: 17, text: "Judge not against a judge: for he judgeth according to that which is just." },
    { n: 18, text: "Go not on the way with a bold man, lest he burden thee with his evils: for he goeth according to his own will, and thou shalt perish together with his folly." },
    { n: 19, text: "Quarrel not with a passionate man, and go not into the desert with a bold man: for blood is as nothing in his sight, and where there is no help he will overthrow thee." },
    { n: 20, text: "Advise not with fools, for they cannot love but such things as please them." },
    { n: 21, text: "Before a stranger do no matter of counsel: for thou knowest not what he will bring forth." },
    { n: 22, text: "Open not thy heart to every man: lest he repay thee with an evil turn, and speak reproachfully to thee." },
  ],
  commentary: [
    { verse: 2, notes: [
      { text: "Bring. Greek, \"overweigh thee,\" (Haydock) or turn the balance of the judge (Calmet) against thee, by money, (Haydock) which sometimes will corrupt kings. It is better, therefore, to avoid all law-suits.", attribution: "Worthington" }
    ] },
    { verse: 4, notes: [
      { text: "Fire.", attribution: "Haydock" }
    ] },
    { verse: 13, notes: [
      { text: ", and Proverbs xxvi. 20. Such contests are full of danger.", attribution: "Haydock" }
    ] },
    { verse: 5, notes: [
      { text: "Family. Or \"ancestors.\" They will be accused of having neglected thy education. People generally associate with those of the like dispositions.", attribution: "Haydock" }
    ] },
    { verse: 14, notes: [
      { text: "Words. Thus the Pharisees attacked our Saviour, Matthew xxii. 15. In popular assemblies it is dangerous, but sometimes requisite to oppose bold declaimers, chap. ix. 25.", attribution: "Haydock" }
    ] },
    { verse: 16, notes: [
      { text: "Power. Thou must consider the debt as thy own, Proverbs vi. 1.", attribution: "Calmet" }
    ] },
    { verse: 20, notes: [
      { text: "Love. Greek, \"keep the word secret. (21) Do no hidden thing before a stranger.\" (Haydock) — The skilful alone must be consulted.", attribution: "Worthington" }
    ] },
    { verse: 22, notes: [
      { text: "Evil. Greek, \"false kindness.\" The rest is omitted. (Haydock) — Samson was undone by Dalilia. When Pompey was going on an embassy, he was taken by king Gentius, who wished to extort his secret from him; but he put his finger in the flame of a candle, that he might see that all his attempts would be fruitless.", attribution: "V. Max. iii. 3." }
    ] },
  ],
};

export default chapter;
